<kui-modal
  *ngIf="modalOpened === true"
  [isOpen]="modalOpened === true"
  (isOpenChange)="modalOpened = false"
  type="info">
  <kp-modal-time-picker
    (closeClicked)="modalOpened = false"
    (saveClicked)="saveClicked($event)"
    [notificationRange]="notificationRange.action"
    svgURL="/assets/icons/reminder.svg"
    [time]="time"></kp-modal-time-picker>
</kui-modal>

<button class="button button-pill button-opaque-border button-reminder-time" (click)="modalOpened = true">
  {{ time }}
  <svg-icon class="dropdown-arrow" src="/assets/icons/chevron-right-nocircle.svg"></svg-icon>
</button>
